import { Text, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import useHelpers from 'hooks/helpers';
import ScLink from 'components/Generic/SitecoreWrappers/ScLink';
import styles from './ArticleFootnote.module.scss';
import { useSitecoreContext } from 'hooks/useSitecoreContext';

const ArticleFootnote = ({ fields, rendering }: ComponentProps): JSX.Element => {
  const { anchorId } = useHelpers(rendering);
  const { sitecoreContext } = useSitecoreContext();

  return (
    <>
      {fields.items && fields.items.length && (
        <div
          id={anchorId}
          data-e2e-component-uid={rendering.uid}
          className={styles['abrdn-article-footnote']}
        >
          <ol>
            {fields.items.map((item) => (
              <li key={item.id}>
                {item.fields.text && (
                  <Text tag="span" field={item.fields.text} className="footnote" />
                )}
                {item.fields.link && (
                  <ScLink
                    field={item.fields.link}
                    className="inline-link inline-link--small revert-underline"
                  />
                )}
              </li>
            ))}
          </ol>
        </div>
      )}
      {sitecoreContext.pageEditing && <p>{[rendering.params.name]}</p>}
    </>
  );
};

export default withDatasourceCheck()(ArticleFootnote);
